import { useEffect } from 'react';
import logo from './logo.svg';
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import Router from './Router';
import { Toaster } from 'react-hot-toast';
import { AllowedPagesProvider } from './context/AllowedPagesContext';
import { useTheme } from './theme/useTheme';

function AppContent() {
  const { colors } = useTheme();

  useEffect(() => {
    // Apply theme background color to body
    document.body.style.backgroundColor = colors.background.secondary;
  }, [colors]);

  return (
    <div className="App">
      <Toaster
        position="top-center"
        reverseOrder={false}
      />
      <AllowedPagesProvider>
        <BrowserRouter>
          <Router />
        </BrowserRouter>
      </AllowedPagesProvider>
    </div>
  );
}

function App() {
  return (
    <AppContent />
  );
}

export default App;
